module.exports = __webpack_public_path__ + "img/3-m.b7040c1c.jpg";